module.exports = __webpack_public_path__ + "static/media/8OLA26.ec196248.jpg";